import {Status} from "../domain";

export const statuses = [
  Status.partner,
  Status.noAnswer,
  Status.noContact,
  Status.notInterested,
  Status.pending,
  Status.trial,
];
